import React, { useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import ExpiredPoliciesTab from "../dashboard/common/ExpiredPoliciesTab";
import PoliciesExpiringNextMonthTab from "../dashboard/common/PoliciesExpiringNextMonthTab";
import PoliciesExpiringNextWeekTab from "../dashboard/common/PoliciesExpiringNextWeekTab";
import PoliciesExpiringThisMonthTab from "../dashboard/common/PoliciesExpiringThisMonthTab";
import PoliciesExpiringThisWeekTab from "../dashboard/common/PoliciesExpiringThisWeekTab";
import PoliciesExpiringTodayTab from "../dashboard/common/PoliciesExpiringTodayTab";
import PoliciesExpiringTomorrowTab from "../dashboard/common/PoliciesExpiringTomorrowTab";
import PoliciesAwaitingRenewalTab from "../dashboard/common/PoliciesAwaitingRenewalTab";

const ExpiringPolicies = () => {
  const [key, setKey] = useState("expiring-today");

  return (
    <div className="content__boxed bg-gray-500 my-3">
      <div className="content__wrap">
        <Tabs
          id="expiring-policies"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3"
        >
          <Tab eventKey="expiring-today" title="Expiring Today">
            <PoliciesExpiringTodayTab />
          </Tab>
          <Tab eventKey="expiring-tomorrow" title="Expiring Tomorrow">
            <PoliciesExpiringTomorrowTab />
          </Tab>
          <Tab eventKey="expiring-week" title="Expiring this Week">
            <PoliciesExpiringThisWeekTab />
          </Tab>
          <Tab eventKey="expiring-next-week" title="Expiring next Week">
            <PoliciesExpiringNextWeekTab />
          </Tab>
          <Tab eventKey="expiring-month" title="Expiring this Month">
            <PoliciesExpiringThisMonthTab />
          </Tab>
          <Tab eventKey="expiring-next-month" title="Expiring next Month">
            <PoliciesExpiringNextMonthTab />
          </Tab>
          <Tab eventKey="expired" title="Expired">
            <ExpiredPoliciesTab />
          </Tab>
          <Tab eventKey="awaiting" title="Awaiting Renewal">
            <PoliciesAwaitingRenewalTab />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default ExpiringPolicies;
